var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.678 16.6071L9.96296 10.8911C7.42063 12.6986 3.91739 12.2565 1.90383 9.87407C-0.109735 7.49165 0.038116 3.96373 2.24396 1.75814C4.44922 -0.448412 7.97748 -0.596902 10.3603 1.41656C12.7432 3.43002 13.1856 6.93359 11.378 9.47614L17.093 15.1921L15.679 16.6061L15.678 16.6071ZM6.48596 2.00013C4.58966 1.9997 2.95365 3.33082 2.56843 5.18758C2.18321 7.04434 3.15467 8.91641 4.89463 9.67038C6.6346 10.4243 8.66486 9.85297 9.7562 8.30219C10.8475 6.75141 10.7 4.64746 9.40296 3.26414L10.008 3.86414L9.32596 3.18414L9.31396 3.17214C8.56574 2.41932 7.54735 1.99727 6.48596 2.00013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4d3e95324595a31831ab207cf6bf9b93.svg";
export { ForwardRef as ReactComponent };